import React from "react";
import { Link } from "react-router-dom";

export default function Navbar(props) {
  let mealPlanClass = "nav-item nav-link ";
  let invoicesClass = "nav-item nav-link ";

  switch (window.location.pathname) {
    case "/mealplans":
      mealPlanClass += "active ";
      break;
    case "/recmealplans":
      mealPlanClass += "active ";
      break;
    case "/recmealplans/new":
      mealPlanClass += "active ";
      break;
    case "/order-summary":
      invoicesClass += "active ";
      break;
    default:
      break;
  }

  return (
    <div className="row">
      <div className="col-12">
        <nav className="nav nav-pills nav-justified">
          <div className="container">
            {props.isLoggedIn ? (
              <nav className="nav nav-pills nav-justified">
                <Link to="/mealplans" className={mealPlanClass}>
                  Orders
                </Link>
                <Link to="/order-summary" className={invoicesClass}>
                  Client Invoices
                </Link>
                <button className="nav-item nav-link btn btn-outline-danger my-2 my-sm-0" onClick={props.signOut}>
                  Sign Out
                </button>
              </nav>
            ) : (
              <></>
            )}
          </div>
        </nav>
      </div>
    </div>
  );
}
